<template lang="pug">
  figure.flex.items-center
    .sr-only(ref="sizer", style="height:12rem")
    template(v-if="format === 'single'")
      .absolute.overlay.bg-contain.bg-no-repeat.bg-center.trans-opacity(v-for="(image, index) in images", v-if="index < 1", :data-flickity-bg-lazyload="thumb(image.url, format)")
        //- :style="'background-image:url(' + thumb(image.url, format) + ')'")
        img.sr-only(v-if="preload", :src="thumb(image.url, format)", :alt="image.alt", @load="$emit('loaded')")
    template(v-else)
      .w-100.flex(:data-format="format", :class="{'justify-center': format !== 'two-up', 'justify-evenly': format === 'two-up'}")
        img.block(v-for="(image, index) in images", v-if="index < 2", :data-flickity-lazyload="thumb(image.url, format)", :class="{'px3': format === 'diptych'}", @load="$emit('loaded')")
</template>

<script>
import Vue from 'vue'
export default {
  name: 'SeriesViewer__Slider__Slide',
  inheritAttrs: false,
  props: {
    images: {type: Array, default: () => []},
    format: {type: String, default: 'single'},
    portraitMode: {type: Boolean, default: false},
    preload: {type: Boolean, default: false}
  },
  data () {
    return {
      winW: window.innerWidth,
      winH: window.innerHeight
    }
  },
  methods: {
    thumb (src, format = 'single') {
      let length = false
      const sizerH = this.$refs.sizer ? this.$refs.sizer.offsetHeight : 0
      if (format === 'single') length = this.portraitMode ? this.winW * 0.68 : this.winH - sizerH
      else if (format === 'diptych') length = this.winH * 0.7
      else if (format === 'two-up') length = this.winH * 0.58
      return length && src ? Vue.thumbSrc(src, length, !this.portraitMode) : false
    }
  }
}
</script>

<style scoped>
.bg-contain{
  top:6rem; left:6rem;
  width:calc(100% - 12rem);
  height:calc(100% - 12rem);
}

img{
  [data-format='default'] &{
    max-height:calc(100vh - 12rem);
  }
  [data-format='diptych'] &{
    max-height:70.091625vh;
  }
  [data-format='two-up'] &{
    max-height:57.795875vh;
  }
}

.trans-opacity{
  opacity:0;
  &.flickity-bg-lazyloaded{
    opacity:1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SeriesViewer__Slider__Slide.vue